export default __webpack_public_path__ + "static/media/_red-cross.27610bdc.ico";